import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import DivOfferPanel from './components/DivOfferPanel';

import {FORM_OFFER_PLAIN, } from '../../util/consts/forms';
import {CLASS_OFFER, } from '../../util/consts/classes';

class OfferPlainPage extends PlainPage {

	constructor(props) {
		super(props);
		this.formPath = FORM_OFFER_PLAIN;
		this.formTitle = 'Пропозиція';
		this.buildInstanceCard = this.buildOfferCard;
	}
	componentDidMount = async () => {
		this.init(CLASS_OFFER)
		document.title = 'BOM. ' + this.formTitle;
	}

	buildOfferCard = (offerInstance) => {
		let card = '';
		
		let productRef = offerInstance.rootField.value.productRef.value;
		if( productRef )
			card += productRef.card;		
		return card;
	}

	renderBody() {
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<DivOfferPanel plain={this} instance={instance} isPlain={true} readOnly={readOnly} />
				</div>
			</div>
		)
	}
}

export default OfferPlainPage;
